import React from "react";
import {
  Show,
  TopToolbar,
  ShowProps,
  TabbedShowLayout,
  Tab,
} from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import { UserResources } from "utils/tools";
import CustomFormLabel from "components/CustomFormLabel";
import Summary from "./Summary";
import ActivateUserButton from "./components/ActivateUserButton";
import InactiveUserButton from "./components/InactiveUserButton";

const UserShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Users",
      link: `/users`,
    },
    {
      title: id,
      link: "",
    },
  ];

  const UserShowAction = (props: any) => {
    const UserResource = UserResources(Number(id));

    return (
      <TopToolbar>
        {UserResource?.admin.status !== "active" ? (
          <ActivateUserButton userId={id} {...props} />
        ) : (
          <InactiveUserButton userId={id} {...props} />
        )}
      </TopToolbar>
    );
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} customFieldName="email" />
      <Show {...props} actions={<UserShowAction />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </Show>
    </>
  );
};

export default UserShow;
